import { html } from "lit";
var icon_adobe_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M16.502 11.325a.583.583 0 00-.502-.35.583.583 0 00-.525.338l-4.888 10.419a.583.583 0 00.525.828h4.468l1.983 4.912c.09.217.302.36.537.361h5.017a.583.583 0 00.536-.828l-7.151-15.68zm12.915-9.158H19.64a.583.583 0 00-.537.816l9.73 22.867c.093.213.304.35.537.35h.117a.583.583 0 00.466-.572V2.75a.583.583 0 00-.536-.583zm-16.544.256a.583.583 0 00-.49-.256h-9.8A.583.583 0 002 2.75v22.82c0 .277.195.516.467.572h.116a.583.583 0 00.537-.35l9.8-22.809a.583.583 0 00-.047-.56z" />
  </svg>
`;
export {
  icon_adobe_default as default
};
//# sourceMappingURL=icon-adobe.js.map
